module.exports = __webpack_public_path__ + "img/day-insurance.32567a5.png";